// extracted by mini-css-extract-plugin
export default {"clients":"clients-module--clients--AcDu6","title":"clients-module--title--E2hlS","slide":"clients-module--slide--3UB7Y"};